import { Button } from '@bosch/react-frok'
import type { MessageContextMenuProps } from './types/MessageContextMenuTypes'
import SVGIconButton from './SVGIconButton'

import './MessageContextMenu.scss'

const MessageContextMenu = ({ items, className = '', style, isDarkTheme }: MessageContextMenuProps) => {
    if (items.length === 0) {
        return null
    }

    return (
        <div className={`message-context-menu ${className} ${isDarkTheme ? '-dark-mode' : ''}`} style={style}>
            {items.map((item) => {
                // For SVG icons, render a custom button with img tag that swaps on hover
                if (typeof item.icon !== 'string') {
                    return <SVGIconButton key={item.id} item={item} />
                }

                // For icon names, use FROK Button
                return (
                    <Button
                        key={item.id}
                        icon={{ iconName: item.icon }}
                        title={item.label}
                        mode='integrated'
                        onClick={item.onClick}
                    />
                )
            })}
        </div>
    )
}

export default MessageContextMenu
